import React, { useEffect } from 'react';
import cn from 'classnames';
import { Features } from 'mod/featureV2/Features';
import { IFeatureBase } from 'mod/featureV2/interface';
import { IFeature } from 'mod/feature/interface';
import { trackPageView } from 'base/utils/tracker';
import VideoBanner from '@base/features/VideoBanner';
import SwiperBanner from '@base/features/SwiperBanner';
import TiledBanner from '@base/features/TiledBanner';
import VideoPopup from '@base/shop/VideoPopup';
import { IOldHomeServerProps } from '@base/shop/interface';
import { themeContext } from '@base/shop/contanst';
import ModuleTitle from '@base/lib/ModuleTitle';
import { FeatureAnchorsBanner } from '@pro/feature/FeatureAnchorsBanner';
import { FeatureSwiperToggleBanner } from '@pro/feature/FeatureSwiperToggleBanner';
import { FeatureBanner } from '@pro/feature/FeatureBanner';
import WatterFall from '@pro/shop/WatterFall';
import TopPromotionBar from '@app/common/TopPromotionBar';
import SwiperProducts from '@app/shop/SwiperProducts';
import SwiperFlashsaleProducts from '@app/shop/SwiperFlashsaleProducts';
import Navigation from '@app/shop/Navigation';
import ProdctListTabs from '@app/shop/ProdctListTabs';
import BlogList from '@app/shop/BlogList';
import SwiperReviews from '@app/shop/SwiperReviews';
import CrowdFundingBanner from '@app/shop/CrowdFundingBanner';
import homeStyles from '@app/shop/index.module.less'
import activityThemeStyles from '@app/theme/activityTheme.module.less';
import titleStyles from 'app/styles/modules/title.module.less';
import TabsProducts from '@app/shop/TabsProducts';
import CouponDrawWheel from '@base/activity/CouponDrawWheel'

//  TODO：使用mod/featureV2/中的 feature 时需要改写 title 组件
function renderContainer(feature: IFeatureBase, children?: React.ReactNode): React.ReactElement {
    return (
        <>
            <div className={homeStyles.wrapper}>
                <ModuleTitle
                    className={cn(titleStyles.title, homeStyles.title)}
                    text={feature.title}
                    link={feature.readMoreLink}
                    linkText={feature.readMoreTitle}
                />
            </div>
            {children}
        </>
    )
}

export default function OldHomePage(props: IOldHomeServerProps) {
    const themeCode = props.theme?.themeCode

    useEffect(() => {
        trackPageView();
    }, []);

    return (
        <div
            className={cn(
                homeStyles.page,
                !!themeCode && activityThemeStyles[`activity-theme-index-${themeCode}`]
            )}
        >
            <TopPromotionBar/>

            <themeContext.Provider value={{ themeCode }}>
                <Features<IFeature>
                    features={props.featureList}
                    render={({ feature }) => {
                        switch (feature.type) {
                            // case 'banner':
                            case 'bannerV2':
                                return (
                                    <FeatureBanner
                                        feature={feature}
                                        renderContainer={renderContainer}
                                    />
                                );
                            case 'swiperToggleBanner':
                                return (
                                    <FeatureSwiperToggleBanner
                                        renderContainer={renderContainer}
                                        feature={feature}
                                    />
                                );
                            case 'anchorsBanner':
                                return (
                                    <FeatureAnchorsBanner
                                        renderContainer={renderContainer}
                                        feature={feature}
                                        containerWidth={1480}
                                    />
                                );
                            case 'videoBanner':
                                return <VideoBanner largeScreen data={feature}/>;
                            case 'swiperBanner':
                                return <SwiperBanner imgShowMode="background" data={feature}/>;
                            case 'tiledBanner':
                                return <TiledBanner data={feature} subWrapClassName={homeStyles.wrapper}/>;
                            case 'swiperProducts':
                                return <SwiperProducts data={feature}/>;
                            case 'swiperFlashsaleProducts':
                                return <SwiperFlashsaleProducts data={feature}/>;
                            case 'navigation':
                                return <Navigation data={feature}/>;
                            case 'pageList':
                                return <ProdctListTabs data={feature}/>;
                            case 'blog':
                                return <BlogList data={feature}/>;
                            case 'swiperReviews':
                                return <SwiperReviews data={feature}/>;
                            case 'waterFall':
                                return <WatterFall data={feature}/>;
                            case 'crowdFundingBanner':
                                return <CrowdFundingBanner data={feature}/>;
                            case 'tabsProducts':
                                return <TabsProducts data={feature as any}/>
                            default:
                                return null
                        }
                    }}
                />

            </themeContext.Provider>

            <CouponDrawWheel/>

            {/*防止最下面模块的 margin-bottom 属性造成页脚上方空白*/}
            <div>&nbsp;</div>

            <VideoPopup/>
        </div>
    )
}